import {ReactElement, useCallback, useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import {AlgoliaWine} from "./winePickerModel";
import {WinePickerResultWine} from "./WinePickerResultWine";
import {useAppDispatch, useAppSelector} from "../../lib/redux/hooks";
import {useIsWinePicked, winePickerActions, winePickerSelectors} from "./winePickerSlice";
import {i18nSelectors} from "../i18n/i18nSlice";
import {Checkbox} from "../../components/UIComponents/Checkbox";

export interface WinePickerFavoritesProps {
    favorites: AlgoliaWine[]
}

export function WinePickerFavorites(props: WinePickerFavoritesProps): ReactElement {
    const [allSelected, setAllSelected] = useState<boolean>(false);

    const dispatch = useAppDispatch();
    const language = useAppSelector(i18nSelectors.language);

    const isWinePicked = useIsWinePicked();
    const pickedWines = useAppSelector(winePickerSelectors.pickedWines);

    const setSelected = useCallback(
        (wine: AlgoliaWine, selected: boolean) =>
            dispatch(winePickerActions.setWinePicked({wine, selected})),
        [dispatch]
    );

    const toggleSelectAll = () => {
        props.favorites.forEach(f => setSelected(f, !allSelected));
    };

    useEffect(()=>{
        setAllSelected(props.favorites.every(isWinePicked));
    }, [pickedWines, isWinePicked, props.favorites]);

    return (
        <div className="w-full mb-10">
            <div className="flex gap-4 items-baseline">
                <div className="font-barlow font-semibold py-4 leading-snug flex">
                    <FormattedMessage id="winepicker.favorites.favorites"/>
                </div>
            </div>
            <ul className="flex flex-col gap-1">
                <li>
                    <div className="flex gap-3 py-4 cursor-pointer select-none" onClick={toggleSelectAll}>
                        <div className="px-2 flex-none h-6">
                            <Checkbox
                                setChecked={toggleSelectAll}
                                checked={allSelected} />
                        </div>
                        <div className="text-light-text">
                            <FormattedMessage id="winepicker.favorites.selectAll" />
                        </div>
                    </div>
                </li>
                {props.favorites.map(wine =>
                    <li key={wine.objectID}>
                        <WinePickerResultWine
                            key={wine.objectID}
                            selected={isWinePicked(wine)}
                            onSetSelected={setSelected}
                            wine={wine}
                            language={language}
                        />
                    </li>
                )}
            </ul>
        </div>
    );
}